export default {"src":"/_next/static/media/wielrennen.dc541977.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};